<nav class="navbar navbar-default navbar-static-top bg">
    <div class="container-fluid">
        <div class="navbar-header">
            <!-- Collapsed Hamburger -->
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse"
                data-target="#app-navbar-collapse">
                <span class="sr-only">Toggle Navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>

            <!-- Branding Image -->
            <a class="navbar-brand" routerLink="/">
                CENTRAL PANEL
            </a>
        </div>

        <!--li *ngIf="!isLogin"><a routerLink="/login">Login</a></li-->

        <div class="collapse navbar-collapse" id="app-navbar-collapse">
            <ul class="nav navbar-nav navbar-right">
                <li *ngIf="(isLogin) && (adminLevel || level == '3')"><a routerLink="/">Tennis Matches</a></li>
                <li *ngIf="(isLogin) && (adminLevel || level == '3')"><a routerLink="/home2">Home2</a></li>
                <!--li *ngIf="(isLogin) && (adminLevel || level == '3')"><a routerLink="/matches-list">Tennis / Soccer</a></li-->
                <li *ngIf="(isLogin) && (adminLevel || level == '3')"><a routerLink="/match">Add Match</a></li>
                <li *ngIf="isLogin"><a routerLink="/dMatch">Add Tennis Match</a></li>
                <li *ngIf="isLogin"><a routerLink="/addMatch">Add Manual Match</a></li>
                <li *ngIf="(isLogin) && (adminLevel)"><a routerLink="/allMatch">M Activities</a></li>
                <li *ngIf="isLogin && adminLevel"><a routerLink="/settings">Settings</a></li>
                <li *ngIf="adminLevel"><a routerLink="/serverStatus">Server Status</a></li>
                <li *ngIf="(isLogin) && (adminLevel || level == '2')"><a routerLink="/liveTv">Live Tv</a></li>
                <li *ngIf="isLogin"><a>{{ userName }}</a></li>
                <li *ngIf="isLogin"><a style="cursor:pointer" (click)="onLogout()">Logout</a></li>
                <!--li *ngIf="adminLevel"><a routerLink="/register">Register</a></li-->
            </ul>
        </div>
    </div>
</nav>